import { useRouter } from "next/router";
import { useCallback } from 'react';
import { queryWithUrl } from '@/const/routerIncludeQuery'
import useRouterWithStylePath from '@/hooks/useRouterWithStylePath';

/** 自动协参的useRouter */
const useRouterWithQuery = () => {
  const router = useRouterWithStylePath();

  /** push函数 */
  const pushWithQuery = useCallback((path: string) => {
    const querys: any[] = []
    
    const [pathWithQuery] = path.split('?')

    /** 跳转路径不符合规则 */
    if (!Object.keys(queryWithUrl).includes(pathWithQuery)) {
      router.push(path)
      return
    }

    /** 取出规则对应的query参数 */
    queryWithUrl[pathWithQuery].forEach(({ query, origin }) => {
      if (origin === 'url' && router.query[query]) {
        querys.push(query + '=' + router.query[query])
      }

      if (origin === 'localStorage' && localStorage.getItem(query)) {
        querys.push(query + '=' + localStorage.getItem(query))
      }

      if (origin === 'sessionStorage' && sessionStorage.getItem(query)) {
        querys.push(query + '=' + sessionStorage.getItem(query))
      }
    })

    const queryString = querys.join('&')
    
    const [, pathQuery] = path.split('?')

    /** 传入路径是否自己携带参数 */
    if (pathQuery) {
      router.push(path + '&' + queryString)
    }
    else {
      router.push(path + '?' + queryString)
    }

  }, [router]);
  
  return {
    ...router,
    push: pushWithQuery
  };
}

export default useRouterWithQuery;
